import React from "react";
import { Box, Button, MenuItem, Paper, Select, TextField, Typography } from "@material-ui/core";
import { Save } from "@material-ui/icons";
import OptionsEditor from "./OptionsEditor";
import { TIPOS_RESPUESTA } from "../helper";

export default function EditorPregunta({
  preguntaEditando,
  onChangeCampoPregunta,
  guardarPregunta,
  updateOption,
  deleteOption,
  addOption,
  loading,
  classes,
}) {
  if (!preguntaEditando) {
    return <Typography color="textSecondary">Cargando editor…</Typography>;
  }
  return (
    <Paper className={classes.editorPaper}>
      <Typography variant="h6" gutterBottom>Editor de pregunta</Typography>

      <TextField
        label="Título"
        value={preguntaEditando?.nombre ?? ""}
        onChange={(e) => onChangeCampoPregunta("nombre", e.target.value)}
        fullWidth
      />
      <Box mt={2} />
      <TextField
        label="Número de orden"
        type="number"
        inputProps={{ min: 1, step: 1 }}
        value={preguntaEditando?.valorb ?? ""}
        onChange={(e) => {
          const v = e.target.value;
          const limpio = v === "" ? "" : String(Number(v)).replace("NaN", "");
          onChangeCampoPregunta("valorb", limpio);
        }}
        fullWidth
      />
      <Box mt={2} />
      <Typography variant="subtitle1" gutterBottom>Seleccione el tipo de respuesta</Typography>

      <Select
        value={["1", "2", "3"].includes(String(preguntaEditando?.valora)) ? Number(preguntaEditando.valora) : ""}
        onChange={(e) => onChangeCampoPregunta("valora", String(e.target.value))}
        fullWidth
        displayEmpty
      >
        <MenuItem value="" disabled>Seleccione una opción...</MenuItem>
        {TIPOS_RESPUESTA.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </Select>

      <Box mt={2} />
      {preguntaEditando?.valora !== "1" && (
        <OptionsEditor
          q={preguntaEditando}
          updateOption={updateOption}
          deleteOption={deleteOption}
          addOption={addOption}
          classes={classes}
        />
      )}

      <Box mt={3} display="flex" justifyContent="center">
        <Button
          color="primary"
          variant="contained"
          startIcon={<Save />}
          onClick={guardarPregunta}
          disabled={
            !(preguntaEditando?.nombre?.trim() && ["1", "2", "3"].includes(String(preguntaEditando?.valora)))
            || loading
          }
        >
          {loading ? 'Guardando…' : 'Guardar'}
        </Button>
      </Box>
    </Paper>
  );
}
